module.exports = __webpack_public_path__ + "img/lp-pendleeth.0ef3e3b1.svg";